<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style src="@/vendor/styles/bootstrap.scss" lang="scss"></style>
<style src="@/vendor/styles/appwork.scss" lang="scss"></style>
<style src="@/vendor/styles/theme-corporate.scss" lang="scss"></style>
<style src="@/vendor/styles/colors.scss" lang="scss"></style>
<style src="@/vendor/styles/uikit.scss" lang="scss"></style>
<style src="./style.scss" lang="scss"></style>

<script>
import { instance } from './api/setup'
import { updatePermissions } from './services/abilityService'
export default {
  name: 'app',
  metaInfo: {
    title: 'Edusystem',
    titleTemplate: '%s - Edusystem'
  },
  created () {
    instance.defaults.headers.common.Authorization = localStorage.getItem('token')
    const permissions = localStorage.getItem('permissions')
    if (permissions) {
      updatePermissions(JSON.parse(permissions))
    }
  },
  updated () {
    // Remove loading state
    setTimeout(() => document.body.classList.remove('app-loading'), 1)
  }
}
</script>
